
import { Button} from "@material-ui/core";
import GeneratePRNModal from "./GeneratePRNModal";
import { useEffect, useState } from "react";
import moment from 'moment'
import { useDispatch } from "react-redux";
import { getLatestValidFromAction } from "../../../../redux/modules/SSSPRN/prnGenerator";
import { getSessionStorage } from "../../../../utils/storage";
import Box from "@material-ui/core/Box";

const SSSContributionGeneratePRN = ({ validTransactions, data, transaction, styles, classes, updateBillerTxn }) => {
    let dispatch = useDispatch();
    const [openModal, setOpenModal] = useState(false)

    useEffect(()=>{
        dispatch(getLatestValidFromAction());
    },[])

    const handleOpenModal = (e) =>{
        setOpenModal(true)
    }

    const handleOnCloseModal = (prnData) => {
        let membershipTypes = getSessionStorage("membershipTypes") || [];
        let membershipTypeVal = "";
        if(prnData) {
            membershipTypeVal = membershipTypes.find(
                (type) => Number(type.id) === Number(prnData.requestBody?.membership_type_id)
            )?.name || "";

            updateBillerTxn({
                code: data.code,
                txnKey: transaction.transactionKey,
                key: "amount",
                value: prnData.amount,
            });
            updateBillerTxn({
                code: data.code,
                txnKey: transaction.transactionKey,
                key: "referenceNumber",
                value: prnData.prn,
            })
            updateBillerTxn({
                code: data.code,
                txnKey: transaction.transactionKey,
                key: "PayorName",
                value: prnData.accountName,
            })
            updateBillerTxn({
                code: data.code,
                txnKey: transaction.transactionKey,
                key: "PaymentType",
                value: membershipTypeVal,
            })
            updateBillerTxn({
                code: data.code,
                txnKey: transaction.transactionKey,
                key: "From",
                value: moment(prnData.applicableDateFrom, "MMYYYY").format("MM/DD/YYYY"),
            })
            updateBillerTxn({
                code: data.code,
                txnKey: transaction.transactionKey,
                key: "To",
                value: moment(prnData.applicableDateTo, "MMYYYY").format("MM/DD/YYYY"),
            })
            updateBillerTxn({
                code: data.code,
                txnKey: transaction.transactionKey,
                key: "To",
                value: moment(prnData.applicableDateTo, "MMYYYY").format("MM/DD/YYYY"),
            })
            updateBillerTxn({
                code: data.code,
                txnKey: transaction.transactionKey,
                key: "isPRNInquired",
                value: false,
            })
        }
        setOpenModal(false)
    }

	return (
        <>
            <Box display="flex" alignItems="center" flexDirection="column" className={classes.buttonContainer}>
                <Button variant="contained" color="inherit" id="generatePRN" size="medium" className={classes.generatePRNbtn} onClick={handleOpenModal}>
                    Generate PRN
                </Button>
                <span className={classes.prnGeneratorLabel}>For contribution only.</span>
            </Box>
            <div>
                <GeneratePRNModal open={openModal} handleOnCloseModal={handleOnCloseModal}/>
            </div>
        </>
	);
};

export default SSSContributionGeneratePRN;